export default __webpack_public_path__ + "static/media/slide4.02e964a9.webp";